import React from "react";
import { Button } from "@/components/ui/button";
import { FLYER_PACKS } from "@/data/gameData";
import { Megaphone, BookOpen, Printer } from "lucide-react";

const FlyerIntro = ({ cash, onStart, onLearn, onDesign, onDone, tipSeen }) => (
  <div className="bg-white rounded-3xl border-4 border-orange-300 p-5 animate-pop-in" data-testid="flyer-game-intro">
    <div className="flex items-center gap-2 mb-1">
      <Megaphone className="w-5 h-5 text-orange-600" />
      <h2 className="font-display text-2xl font-bold text-slate-900">Marketing Day: hand out flyers</h2>
    </div>
    <p className="text-slate-600 font-medium text-sm mb-4">
      Buy a flyer pack, then tap neighbors who look interested. Every lead becomes a <b>new customer tomorrow</b>! Flyers cost money now — that&apos;s a marketing expense.
    </p>
    <div className="bg-rose-50 border-2 border-rose-200 rounded-2xl p-3 mb-4 text-sm font-heading font-bold text-rose-800" data-testid="flyer-safety-note">
      🛡️ Real-life rule: only hand out flyers WITH a grown-up, on streets you know, and never go inside anyone&apos;s house.
    </div>
    <div className="grid sm:grid-cols-3 gap-3 mb-4">
      {FLYER_PACKS.map((p) => (
        <button
          key={p.id}
          onClick={() => onStart(p)}
          disabled={cash < p.price}
          data-testid={`flyer-pack-${p.id}`}
          className="relative text-left bg-orange-50 border-2 border-orange-300 rounded-2xl p-4 card-3d disabled:opacity-40"
        >
          {p.tag && <span className="absolute -top-2 right-3 bg-emerald-500 text-white text-[10px] font-black uppercase px-2 py-0.5 rounded-full">{p.tag}</span>}
          <div className="text-3xl mb-1">{p.emoji}</div>
          <div className="font-heading font-black text-slate-900">{p.name}</div>
          <div className="text-sm font-bold text-slate-700">{p.flyers} flyers · <span className="text-orange-700">${p.price}</span></div>
          <div className="text-[10px] text-slate-500 font-bold">{`$${(p.price / p.flyers).toFixed(2)} each`}</div>
        </button>
      ))}
    </div>
    <div className="flex flex-wrap gap-2">
      {!tipSeen && (
        <Button onClick={onLearn} data-testid="flyer-learn-btn" className="bg-blue-500 hover:bg-blue-600 text-white font-heading font-black rounded-2xl btn-3d border-2 border-blue-600">
          <BookOpen className="w-4 h-4 mr-1" /> Read: Spread the word
        </Button>
      )}
      <Button onClick={onDesign} data-testid="flyer-design-link" className="bg-white hover:bg-slate-50 text-slate-900 font-heading font-black rounded-2xl btn-3d border-2 border-slate-300">
        <Printer className="w-4 h-4 mr-1" /> Design my flyer
      </Button>
      <Button onClick={onDone} data-testid="flyer-cancel-btn" variant="ghost" className="font-heading font-black text-slate-500">Back</Button>
    </div>
  </div>
);

export default FlyerIntro;
